import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './pages/landing_page.js';


import Login from './pages/Login';
import Signup from './pages/Signup';
import Verify from './pages/Verify';
import Verify2FA from './pages/Verify2FA';
import ForgotPassword from './pages/ForgotPassword'; // Naya Page
import ResetPassword from './pages/ResetPassword';   // Naya Page
import Dashboard from './pages/Dashboard';           // Naya Page
import Agent from './pages/Agent';                   // Agent Chat Page
import ProtectedRoute from './ProtectedRoute';       // Route protection
import Landing from './pages/landing_page.js';

const LoadingOverlay = ({ show }) => {
  if (!show) return null;
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <div className="page-loader__content">
        <div className="page-loader__orb" aria-hidden="true" />
        <div className="page-loader__text">
          <div className="page-loader__title">Cortex</div>
          <div className="page-loader__subtitle">Getting things ready...</div>
          <div className="page-loader__bar">
            <span />
          </div>
        </div>
      </div>
    </div>
  );
};

const AppRoutes = () => {
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setIsInitialLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // If an OAuth token was provided in the URL (e.g. ?token=...), store it and redirect to dashboard
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      // Remove token param from URL
      window.history.replaceState({}, document.title, window.location.pathname);
      navigate('/dashboard');
    }

    const authPaths = ['/login', '/signup', '/verify', '/forgot-password', '/reset-password'];
    const isAuthPage = authPaths.includes(location.pathname);
    if (isAuthPage) {
      document.documentElement.setAttribute('data-theme', 'dark');
      return;
    }

    if (location.pathname === '/') {
      document.documentElement.setAttribute('data-theme', 'dark');
      return;
    }
    const theme = localStorage.getItem('theme') || 'dark';
    document.documentElement.setAttribute('data-theme', theme);
  }, [location.pathname, location.search, navigate]);

  const WithTitle = ({ title, children }) => {
    useEffect(() => {
      document.title = title;
    }, [title]);
    return children;
  };

  // Helper component - agar user logged in hai to /dashboard bhej do, nahi to login dikha do
  const LoginPage = () => {
    const token = localStorage.getItem('token');
    if (token) {
      return <Navigate to="/dashboard" replace />;
    }
    return <WithTitle title="Cortex - Login"><Login /></WithTitle>;
  };

  const SignupPage = () => {
    const token = localStorage.getItem('token');
    if (token) {
      return <Navigate to="/dashboard" replace />;
    }
    return <WithTitle title="Cortex - Signup"><Signup /></WithTitle>;
  };

  if (isInitialLoading) {
    return <LoadingOverlay show />;
  }

  return (
    <>
      <LoadingOverlay show={false} />
      <Routes>

        <Route path="/" element={<Landing/>} />

        <Route path="/login" element={<LoginPage />} />

        <Route path="/signup" element={<SignupPage />} />

        <Route path="/verify" element={<WithTitle title="Cortex - Verify"><Verify /></WithTitle>} />
        <Route path="/verify-2fa" element={<WithTitle title="Cortex - Two-Factor"><Verify2FA /></WithTitle>} />

        <Route path="/forgot-password" element={<WithTitle title="Cortex - Forgot Password"><ForgotPassword /></WithTitle>} />

        <Route path="/reset-password" element={<WithTitle title="Cortex - Reset Password"><ResetPassword /></WithTitle>} />

        <Route path="/dashboard/*" element={
          <ProtectedRoute>
            <WithTitle title="Cortex - Dashboard"><Dashboard /></WithTitle>
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <WithTitle title="Cortex - Settings"><Dashboard /></WithTitle>
          </ProtectedRoute>
        } />
        <Route path="/tasks" element={
          <ProtectedRoute>
            <WithTitle title="Cortex - Tasks"><Dashboard /></WithTitle>
          </ProtectedRoute>
        } />
        <Route path="/calendar" element={
          <ProtectedRoute>
            <WithTitle title="Cortex - Calendar"><Dashboard /></WithTitle>
          </ProtectedRoute>
        } />
        <Route path="/agent" element={
          <ProtectedRoute>
            <WithTitle title="Cortex - Agent"><Agent /></WithTitle>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <WithTitle title="Cortex - Profile"><Dashboard /></WithTitle>
          </ProtectedRoute>
        } />

      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
      <AppRoutes />
    </Router>
  );
}



export default App;